import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListWithLoadMore.css';
import Button from '../Button';
import openIcon from './otworz.svg';

class ListWithLoadMore extends React.Component {
  render() {
    if(this.props.table) {
      return (
        <tbody>
          {this.props.children}
          {this.props.hasMore ? (
            <tr>
              <div className={s.showMoreIcon}>
                <Button
                  buttonClass={'transparent'}
                  block
                  type="button"
                  onClick={this.props.loadMore}>
                  <img src={openIcon} width="38" height="38" />
                </Button>
              </div>
            </tr>
          ) : null}
        </tbody>
      );
    }
    return (
      <div>
        {this.props.children}
        {this.props.hasMore ? (
          <div className={s.showMoreIcon}>
            <Button
              buttonClass={'transparent'}
              block
              type="button"
              onClick={this.props.loadMore}>
              <img src={openIcon} width="38" height="38" />
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

ListWithLoadMore.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
  children: PropTypes.node,
  table: PropTypes.bool,
};

export default withStyles(s)(ListWithLoadMore);



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll/ListWithLoadMore.js